import css from './style.module.scss';
import Prose from '../Prose';
import Gallery from '../Gallery';
import { gql } from '../../util/fetchGql';
import Image from 'next/image';
import ProductCard, { PRODUCT_CARD_FRAGMENT } from '../ProductCard';
import Deck from '../Deck';
import { Fragment } from 'react';

export const POST_CONTENT_FRAGMENT = gql`
	fragment PostContent on postContent_MatrixField {
        ... on MatrixBlockInterface {
            id
            typeHandle
        }
        ... on postContent_text_BlockType {
            text
        }
        ... on postContent_embed_BlockType {
            embedCode
        }
        ... on postContent_gallery_BlockType {
            images {
                id
                url @transform (
                    width: 3440
                    height: 1840
                )
            }
        }
		... on postContent_split_BlockType {
			text
			image {
				url @transform (width: 1120)
				width
				height
			}
			imagePosition
		}
		... on postContent_products_BlockType {
			heading
			products {
				...ProductCard
			}
		}
	}
	${PRODUCT_CARD_FRAGMENT}
`;

export default function PostContent ({ postContent }) {
	return (
		<div className={css.content}>
			{postContent.map(block => {
				switch (block.typeHandle) {
					case 'text':
						return <Prose key={block.id} className={css.text}>{block.text}</Prose>;
					case 'embed':
						return (
							<div
								key={block.id}
								dangerouslySetInnerHTML={{__html:block.embedCode}}
								className={css.embed}
							/>
						);
					case 'gallery':
						return (
							<div key={block.id} className={css.gallery}>
								<Gallery images={block.images} unwrapped />
							</div>
						);
					case 'split':
						const text = <Prose>{block.text}</Prose>;
						return (
							<div key={block.id} className={css.split}>
								{block.imagePosition === 'right' && text}
								<figure>
									<Image unoptimized
										src={block.image[0].url}
										width={1120}
										height={(block.image[0].height / block.image[0].width) * 1120}
									/>
								</figure>
								{block.imagePosition === 'left' && text}
							</div>
						);
					case 'products':
						return (
							<Fragment key={block.id}>
								{block.heading && <h2 className={css.heading}>{block.heading}</h2>}
								<Deck scroll pullLeft>
									{block.products.map(product => <ProductCard {...product} />)}
								</Deck>
							</Fragment>
						);
				}
			})}
		</div>
	);
}
